import * as React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { nanoid } from 'nanoid';

interface PartnerType {
  id?: number | string;
  img_path: string;
  link: string;
  label?: Record<string, string>;
}

const vendorFeaturedIn: PartnerType[] = [
  {
    img_path: '/partner_logos/bunte.png',
    link: 'https://unternehmen.bunte.de/marketing-fuer-restaurants.html',
  },
  {
    img_path: '/partner_logos/starting-up.png',
    link: 'https://www.starting-up.de/geschaeftsideen/gruenderstorys/4takeawaycom-das-naechste-100-mio-euro-projekt.html',
  },
  {
    img_path: '/partner_logos/grunder-de.png',
    link: 'https://www.gruender.de/interviews/4takeaway-gruender/',
  },
  {
    img_path: '/partner_logos/Focus.png',
    link: 'https://unternehmen.focus.de/4takeaway.html',
  },
  {
    img_path: '/partner_logos/business-leben.png',
    link: 'https://businessleben.de/4takeaway-fuer-gastronomen',
  },
  {
    img_path: '/partner_logos/gastrotel.png',
    link: 'https://www.gastrotel.de/news/newsdetail/news/show/News/neue-impulse-im-lieferdienstmarkt/',
  },
  {
    img_path: '/partner_logos/CHIP.png',
    link: 'https://unternehmen.chip.de/4takeaway.html',
  },
  // {
  //   id: 5,
  //   img_path: '/partner_logos/wissen-de-Logo.jpg',
  //   link: 'https://www.wissen.de/thomas-wos-einstieg-die-digitalisierung-mit-einem-profi',
  // },
  // {
  //   id: 6,
  //   img_path: '/partner_logos/gastro.png',
  //   link: 'https://gastro-magazin.com/alternative-zu-lieferando-unser-testsieger/',
  // },
  // {
  //   id: 8,
  //   img_path: '/partner_logos/forbes-01.png',
  //   link: 'https://www.forbes.com/sites/julianvigo/2019/07/30/the-malaise-of-peak-wokeism-within-online-culture',
  // },
  // {
  //   id: 9,
  //   img_path: '/partner_logos/ak-kurier.png',
  //   link: 'https://www.ak-kurier.de/akkurier/www/artikel/131328-alternative-zu-lieferando--warum-der-testsieger-4takeaway-heisst',
  // },
  // {
  //   id: 10,
  //   img_path: '/partner_logos/krone.png',
  //   link: 'https://www.krone.at/1729353',
  // },
  // {
  //   id: 11,
  //   img_path: '/partner_logos/yahoo.png',
  //   link: 'https://finance.yahoo.com/news/advertisement-hotels-makes-thomas-wos-091000810.html',
  // },
  // {
  //   id: 12,
  //   img_path: '/partner_logos/zeitung.png',
  //   link: 'https://www.mz.de/deutschland-und-welt/wirtschaft/rekordsumme-fur-neues-start-up-20-millionen-euro-fur-thomas-wos-1195777',
  // },
  // {
  //   id: 13,
  //   img_path: '/partner_logos/aktiencheck.png',
  //   link: 'https://www.aktiencheck.de/exklusiv/Artikel-Millionenschweres_Investment_fuer_Startup_Unternehmer_Thomas_Wos-7342906',
  // },
  // {
  //   id: 14,
  //   img_path: '/partner_logos/wirtschaft.png',
  //   link: 'http://www.wirtschaft.ch/Expansion+nach+Dubai+Thomas+Wos+mischt+den+Immobilienmarkt+auf/699575/detail.htm#image0',
  // },
  // {
  //   id: 15,
  //   img_path: '/partner_logos/erfolg.png',
  //   link: 'https://www.erfolg-magazin.de/der-immobilienmarkt-gerald-hoerhan-und-thomas-wos-auf-erfolgskurs/',
  // },
  // {
  //   id: 16,
  //   img_path: '/partner_logos/eurasis.png',
  //   link: 'https://www.eurasischesmagazin.de/artikel/Thomas-Wos-macht-es-vor-Immobilienbranche-in-Dubai-hat-Zukunft/20170222',
  // },
  // {
  //   id: 17,
  //   img_path: '/partner_logos/wohnnet.png',
  //   link: 'https://www.wohnnet.at/business/branchen-news/immobilienboom-dubai-30678410',
  // },

  // {
  //   id: 18,
  //   img_path: '/partner_logos/immomagazine.png',
  //   link: 'http://www.immo-magazin.de/traumimmobilie-in-den-arabischen-emiraten-gefaellig/',
  // },
  // {
  //   id: 19,
  //   img_path: '/partner_logos/investor.png',
  //   link: 'https://www.investor-verlag.de/aktuelle-marktlage/wos-swiss-investments-ag-will-20-millionen-dollar-in-immobilienplattform-all-realestates-anlegen/',
  // },
  // {
  //   id: 20,
  //   img_path: '/partner_logos/gevestor.png',
  //   link: 'https://www.gevestor.de/details/immobilie-in-den-vereinigten-arabischen-emiraten-kaufen-so-gehts-828985.html',
  // },
  // {
  //   id: 21,
  //   img_path: '/partner_logos/ok.png',
  //   link: 'https://www.ok-magazin.de/lifestyle/reisen/auf-erfolgskurs-thomas-wos-erobert-die-vereinigten-arabischen-emirate-53012.html',
  // },
  // {
  //   id: 22,
  //   img_path: '/partner_logos/arcor.png',
  //   link: 'https://www.arcor.de/article/hub01-home-leben-job/7440759',
  // },
  // {
  //   id: 23,
  //   img_path: '/partner_logos/recklingshauser.png',
  //   link: 'http://www.recklinghaeuser-zeitung.de/ratgeber/weitere/rz/Thomas-Wos-investiert-in-die-Immobilienbranche;art351343,2232965',
  // },
  // {
  //   id: 24,
  //   img_path: '/partner_logos/tag24.png',
  //   link: 'https://www.tag24.de/nachrichten/all-realestates-immobiliensuche-immobilie-dubai-reisen-wohnen-672708',
  // },
  // {
  //   id: 25,
  //   img_path: '/partner_logos/finanzwelt.png',
  //   link: 'http://finanzwelt.de/der-dubaier-immobilienmarkt-boomt/',
  // },

  // {
  //   id: 26,
  //   img_path: '/partner_logos/oe24.png',
  //   link: 'http://www.oe24.at/businesslive/service/Investor-Thomas-Wos-steigt-bei-Immobilienportal-fuer-Dubai-ein/341448804',
  // },
  // {
  //   id: 27,
  //   img_path: '/partner_logos/immobilien.png',
  //   link: 'https://www.immobilien.de/Thomas-Wos-beeindruckt-mit-Immobilien-Investment-The-Wos-die-neue-Hotelkette-des-Unternehmers-355690.html',
  // },
  // {
  //   id: 28,
  //   img_path: '/partner_logos/schwabis.png',
  //   link: 'http://www.schwaebische-post.de/unternehmen/wos-swiss-investments-ag-investiert-20-millionen-dollar-in-immobilienplattform-all-realestatescom/1687988/',
  // },
  // {
  //   id: 29,
  //   img_path: '/partner_logos/frankfuter.png',
  //   link: 'https://partner.fr.de/wos-swiss-investments-ag-steigt-bei-all-realestates-ein.html',
  // },
  // {
  //   id: 30,
  //   img_path: '/partner_logos/topmagazine.png',
  //   link: 'https://www.top-magazin.de/blog/2020/09/28/digitalisierung-als-zukunftschance/',
  // },
  // {
  //   id: 31,
  //   img_path: '/partner_logos/bundesfinanz.png',
  //   link: 'https://unternehmen.focus.de/thomas-wos-investiert-20-millionen-dollar.html',
  // },
  // {
  //   id: 32,
  //   img_path: '/partner_logos/money.jpg',
  //   link: 'https://www.handelsblatt.com/adv/firmen/thomas-wos-investiert-in-all-realestates.html',
  // },
  {
    id: 33,
    img_path: '/partner_logos/handelsblatt.png',
    link: 'https://www.handelsblatt.com/adv/firmen/4takeaway.html',
  },
  // {
  //   id: 34,
  //   img_path: '/partner_logos/immoanleger.png',
  //   link: 'http://www.immoanleger.de/immobilien-dubai/',
  // },

  // {
  //   id: 35,
  //   img_path: '/partner_logos/antenne.png',
  //   link: 'https://www.antenne.de/experten-tipps/geld-und-recht/immobilien-im-ausland-wie-thomas-wos-den-nahen-osten-erobert',
  // },
  // {
  //   id: 36,
  //   img_path: '/partner_logos/esslinger.png',
  //   link: 'https://www.esslinger-zeitung.de/ratgeber/tipps-und-trends_artikel,-so-funktioniert-die-immobilienbranche-in-der-zukunft-jennifer-wos-und-thomas-wos-sehen-viel-potenzi-_arid,2207794.html',
  // },
  // {
  //   id: 37,
  //   img_path: '/partner_logos/munichtv.png',
  //   link: 'https://www.muenchen.tv/nicht-nur-muenchener-immobilien-sind-teuer-auch-der-nahe-osten-ist-kaum-noch-zu-bezahlen-276835/',
  // },
  // {
  //   id: 38,
  //   img_path: '/partner_logos/blick.png',
  //   link: 'https://www.blick-aktuell.de/Nachrichten/In-Immobilien-investieren-Thomas-Wos-macht-es-vor-339776.html',
  // },
  // {
  //   id: 39,
  //   img_path: '/partner_logos/tagblatt.png',
  //   link: 'https://www.tagblatt.de/Nachrichten/Thomas-Wos-zieht-es-nach-Dubai-379861.html',
  // },
  // {
  //   id: 40,
  //   img_path: '/partner_logos/morgen.png',
  //   link: 'https://www.morgenweb.de/mannheimer-morgen_artikel,-wirtschaft-wos-swiss-investments-ag-plant-investment-von-20-millionen-dollar-in-online-immobilienmar-_arid,1289118.html',
  // },
  // {
  //   id: 41,
  //   img_path: '/partner_logos/zeitung2.png',
  //   link: 'http://www.winterthurer-zeitung.ch/lifestyle/detail/article/warum-es-das-unternehmerpaar-thomas-wos-und-jennifer-wos-investmenttechnisch-in-die-vereinigten-arab/',
  // },
  // {
  //   id: 42,
  //   img_path: '/partner_logos/radio98.png',
  //   link: 'https://www.paradiso.de/thomas-wos-und-seine-investitionen-in-dubai',
  // },
  // {
  //   id: 43,
  //   img_path: '/partner_logos/galler.png',
  //   link: 'http://www.st-galler-nachrichten.ch/lifestyle/detail/article/thomas-wos-zieht-es-in-den-nahen-osten-00145823/',
  // },

  // {
  //   id: 44,
  //   img_path: '/partner_logos/merkur.png',
  //   link: 'https://www.merkur.de/leben/wohnen/swiss-investments-investiert-immobilienbranche-dubai-10078471.html',
  // },
  // {
  //   id: 45,
  //   img_path: '/partner_logos/kreiszeitug.png',
  //   link: 'https://www.kreiszeitung-wochenblatt.de/ueberregional/service/thomas-wos-plant-neue-aktivitaeten-in-dubai-d117538.html',
  // },
  // {
  //   id: 46,
  //   img_path: '/partner_logos/niederausitz.png',
  //   link: 'https://www.niederlausitz-aktuell.de/nachbarn/73268/immobilienmarkt-in-dubai-das-terrain-von-thomas-wos.html',
  // },
  // {
  //   id: 47,
  //   img_path: '/partner_logos/az.png',
  //   link: 'http://www.saz-aktuell.com/thomas-wos-kuendigt-ein-investment-in-den-vereinigten-arabischen-emiraten-an/',
  // },
  // {
  //   id: 48,
  //   img_path: '/partner_logos/maifranken.png',
  //   link: 'https://www.mainfranken24.de/thomas-wos-erfolgreich-in-unterschiedlichen-bereichen/',
  // },
  // {
  //   id: 49,
  //   img_path: '/partner_logos/tagesspiel.png',
  //   link: 'https://www.tagesspiegel.de/advertorials/anzeige-traumimmobilien-am-persischen-golf/22884968.html?version=5&id=22884968',
  // },
  // {
  //   id: 50,
  //   img_path: '/partner_logos/radioHamburg.png',
  //   link: 'https://www.radiohamburg.de/Nachrichten/Services/Finanzen/2018/August/Lebenstraum-Dubai-Auch-Thomas-Wos-investiert-hier',
  // },
  // {
  //   id: 51,
  //   img_path: '/partner_logos/kosmo.png',
  //   link: 'https://www.kosmo.at/thomas-wos-erkennt-das-potenzial-der-immobilienbranche-in-dubai/',
  // },
  // {
  //   id: 52,
  //   img_path: '/partner_logos/nqOnline.png',
  //   link: 'https://www.nq-online.de/nq_62_43602-_In-Dubai-gibt-es-einen-Immobilienboom.html',
  // },

  // {
  //   id: 53,
  //   img_path: '/partner_logos/thebetterdays.png',
  //   link: 'https://thebetterdays.de/traumhaftes-dubai-all-realestates-machts-moeglich/',
  // },
  // {
  //   id: 54,
  //   img_path: '/partner_logos/freenet.png',
  //   link: 'https://www.freenet.de/finanzen/immobilien/how-to-make-it-in-dubai_6768600_4707602.html',
  // },
  // {
  //   id: 55,
  //   img_path: '/partner_logos/saechsische.png',
  //   link: 'https://www.saechsische.de/traumimmobilie-in-dubai-mit-all-realestates-finden-1292.html',
  // },
  // {
  //   id: 56,
  //   img_path: '/partner_logos/experto.png',
  //   link: 'https://www.experto.de/businesstipps/e-mail-marketing-thomas-wos-mit-rekordinvestition-gefoerdert.html',
  // },
  // {
  //   id: 57,
  //   img_path: '/partner_logos/meinbezrik.png',
  //   link: 'https://www.meinbezirk.at/oberwart/c-wirtschaft/warum-thomas-wos-mehrere-millionen-in-dubai-investiert_a2966697',
  // },
  {
    id: 58,
    img_path: '/partner_logos/welt-logo.png',
    link: 'https://unternehmen.welt.de/computer-digital/4takeaway.html',
  },
];

const HeroFeaturedIn = ({
  partners,
  lang,
}: {
  partners: PartnerType[];
  lang: string;
}) => {
  return (
    <div className="container flex items-center justify-center py-2">
      <div className="vendor-partner-slide-wrapper flex items-center justify-start overflow-hidden">
        <div className="vendor-partner-slide flex gap-x-6">
          <Slideshow partners={partners} lang={lang} />
        </div>
        <div className="vendor-partner-slide ml-6 flex gap-x-6">
          <Slideshow partners={partners} lang={lang} />
        </div>
      </div>
    </div>
  );
};

export default HeroFeaturedIn;

function Slideshow({
  partners,
  lang,
}: {
  partners: PartnerType[];
  lang: string;
}) {
  const generateAlt = (link: string) => {
    const image = link.split('/')[2].split('.')[0];
    return image + ' logo';
  };
  const partnerItems: PartnerType[] =
    partners?.length > 0 ? partners : vendorFeaturedIn;
  return (
    <>
      {partnerItems.map((item: PartnerType) => {
        return (
          <div
            // href={item.link}
            key={item?.id ?? nanoid(5)}
            className="relative h-[40px] w-[130px]"
            // target="_blank"
            // rel="noopener noreferrer"
          >
            <Image
              src={item.img_path}
              fill
              alt={item?.label?.[lang] ?? generateAlt(item.img_path)}
              className="object-contain"
            />
          </div>
        );
      })}
    </>
  );
}
